export default __webpack_public_path__ + "aa15c3b8a42222dbc426e1d64a6ac680.svg";